/* eslint-disable @typescript-eslint/no-explicit-any */
/* eslint-disable camelcase */
import { getCollectionReference, convertTimeStamp } from 'services'
import { collectionNames } from 'constant'

export const getNewsArticlesData = ({ articles, limit, order, orderRef }: any) => {
  // eslint-disable-next-line no-async-promise-executor
  return new Promise(async (resolve, reject) => {
    try {
      const news: any = []

      const startAfter = articles.length > 0 ? articles[articles.length - 1].scraped_at : null

      /** Create a ref collection of news articles */
      let newsArticlesRef: any = getCollectionReference(collectionNames.NEWS_ARTICLES)

      newsArticlesRef = newsArticlesRef.orderBy(orderRef, order)

      if (startAfter) {
        newsArticlesRef = newsArticlesRef.startAfter(startAfter)
      }

      await newsArticlesRef
        .limit(limit)
        .get()
        .then(async (snapshot: any) => {
          if (snapshot.size > 0) {
            snapshot.docs.map((doc: any) => {
              news.push({ ...doc.data(), id: doc.id })
            })

            resolve({
              articles: news,
              limit: limit,
              hasDataToLoad: true,
            })
          } else {
            resolve({
              articles: news,
              limit: limit,
              hasDataToLoad: false,
            })
          }
        })
    } catch (error) {
      console.log('getNewsArticlesData | error', error)
      reject(error)
    }
  })
}

export const setArticleVisibility = (doc: any) => {
  // eslint-disable-next-line no-async-promise-executor
  return new Promise(async (resolve, reject) => {
    try {
      /** Create a ref collection of news articles */
      const newsArticlesRef = getCollectionReference(collectionNames.NEWS_ARTICLES)

      const { id, active, scraped_at, original_scraped_date, ...rest } = doc

      let params = {
        ...rest,
        active: active || active == null ? false : true,
      }

      if (active || active == null) {
        // hide
        params = {
          ...params,
          original_scraped_date: scraped_at,
          scraped_at: await convertTimeStamp('January 1, 2021'),
        }
      } else {
        // unhide
        params = {
          ...params,
          scraped_at: original_scraped_date ? original_scraped_date : scraped_at,
        }
      }

      newsArticlesRef.doc(id).update(params)

      resolve({ success: true, params, id })
    } catch (error) {
      console.log('getSolanaNFtCollections | error', error)
      reject(error)
    }
  })
}
